// ============================================================
// useDebouncedValue.ts
// Retourne une version retardée d'une valeur. Utile pour ne pas
// déclencher d'effets coûteux (fetch API) à chaque keystroke ou
// changement rapide.
//
// La valeur "live" reste accessible séparément si on en a besoin
// (ex: l'input affiche la valeur instantanée, le fetch utilise
// la version debouncée).
//
// Usage :
//   const debouncedFilters = useDebouncedValue(filters, 300);
//   useEffect(() => { fetch(debouncedFilters); }, [debouncedFilters]);
// ============================================================

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);     // reset si value change avant la fin
  }, [value, delayMs]);

  return debounced;
}
